import React from 'react';
import { injectIntl } from 'react-intl';
import { Button, CircularProgress, Grid } from '@mui/material';
import LanguageRadioGroup from '../../../../../components/LanguageRadioGroup/LanguageRadioGroup';
import './PDFExportCard.scss';

const PDFExportCard = props => {
  const { intl, loading, language, onChangeLanguage, onGenerate } = props;
  return (
    <Grid className="pdf-export-card" container sx={{
      justifyContent: "center"
    }}>
      <Grid>
        <LanguageRadioGroup name="language" value={language} onChange={onChangeLanguage} />
      </Grid>
      <Grid style={{ width: '100%' }}>
        <Grid container sx={{
          justifyContent: "flex-end"
        }}>
          <Grid>
            <Button color="primary" variant="contained" disabled={loading} onClick={onGenerate}>
              {loading ? <CircularProgress size={24.5} /> : `${intl.formatMessage({ id: 'Export_action' })} PDF`}
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default injectIntl(PDFExportCard);
